import type { Guest } from "./types";

export interface RsvpAnswer { email: string; status: "pending" | "accepted" | "declined" }

/** Guest list updated from RSVP answers, matched by email. Accepted becomes Confirmed and declined becomes Declined; people already marked Attended are left alone. */
export function applyRsvpAnswers(guests: Guest[], answers: RsvpAnswer[]): { guests: Guest[]; changed: number } {
  const by = new Map(answers.map((a) => [a.email.trim().toLowerCase(), a.status]));
  let changed = 0;
  const next = guests.map((g) => {
    const a = g.email ? by.get(g.email.trim().toLowerCase()) : undefined;
    if (!a || a === "pending" || g.status === "attended") return g;
    const status = a === "accepted" ? "confirmed" : "declined";
    if (g.status === status) return g;
    changed++;
    return { ...g, status } as Guest;
  });
  return { guests: next, changed };
}
